import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";
import { useLang } from "../lib/i18n";
import { Field, useBusy } from "../components/common";
import { AuthShell } from "./ForgotPassword";

export default function AcceptInvite() {
  const { token } = useParams();
  const { t, setLang } = useLang();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState({ password: "", confirm: "" });
  const [done, setDone] = useState(false);
  const [busy, run] = useBusy();
  useEffect(() => {
    api.get(`/public/invite/${token}`).then((r) => { setInfo(r.data); setLang(r.data.language, false); }).catch((e) => setError(errMsg(e)));
  }, [token]); // eslint-disable-line react-hooks/exhaustive-deps
  const submit = (e) => run(async () => {
    e.preventDefault();
    if (pw.password !== pw.confirm) return toast.error(t("Passwords do not match", "Las contraseñas no coinciden"));
    try { await api.post(`/public/invite/${token}`, { password: pw.password }); setDone(true); } catch (err) { toast.error(errMsg(err)); }
  });
  return (
    <AuthShell testid="accept-invite-page">
      <h1 className="text-3xl font-extrabold text-slate-900">{t("Create your password", "Cree su contraseña")}</h1>
      {error && <p className="mt-4 p-4 rounded-xl bg-red-50 text-red-800" data-testid="accept-invite-error">{error}</p>}
      {done && <p className="mt-4 p-4 rounded-xl bg-emerald-50 text-emerald-800" data-testid="accept-invite-done">{t("Your account is ready. Sign in with your email and new password.", "Su cuenta está lista. Inicie sesión con su correo y su nueva contraseña.")}</p>}
      {info && !done && !error && (
        <form onSubmit={submit} className="mt-6 grid gap-4" data-testid="accept-invite-form">
          <p className="text-slate-600">{info.company} · <b>{info.name}</b> · {info.email}</p>
          <Field label={t("New password (min 8)", "Nueva contraseña (mín 8)")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.password} onChange={(e) => setPw({ ...pw, password: e.target.value })} data-testid="accept-invite-password" /></Field>
          <Field label={t("Confirm password", "Confirmar contraseña")}><input className="inp" type="password" required minLength={8} autoComplete="new-password" value={pw.confirm} onChange={(e) => setPw({ ...pw, confirm: e.target.value })} data-testid="accept-invite-confirm" /></Field>
          <button className="btn-primary h-14 text-base" disabled={busy} data-testid="accept-invite-submit">{t("Create account", "Crear cuenta")}</button>
        </form>
      )}
      <Link to="/login" className="mt-6 text-sm font-semibold text-[#D9531E]" data-testid="accept-invite-login-link">{t("Go to sign in", "Ir a iniciar sesión")}</Link>
    </AuthShell>
  );
}
